module.exports = __webpack_public_path__ + "static/media/011-Aufraeumen_oV_ID_1.bb64ce27.mp3";